import {useAppNavigation} from './useAppNavigation';

export function useSettingsNavigation(_currentScreen?: string) {
  const {navigate, goBack} = useAppNavigation();

  return {
    navigateToSettingsScreen: navigate,
    navigate,
    goBack,
  };
}
